import axios from "axios";


const BASE_URL="https://banglacalender.in/api/forms";

const getUserPolicy = async (authToken) => {
  try {
    const resPolicy = await axios.get(BASE_URL, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    console.log("resPolicy:", resPolicy);

    return resPolicy.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status code outside 2xx
      console.error("Response error:", error.response.data);
      throw new Error(error.response.data?.message || "Failed to fetch user policy");
    } else if (error.request) {
      // Request made but no response received
      console.error("No response received:", error.request);
      throw new Error("No response from server. Please try again later.");
    } else {
      // Something else triggered the error
      console.error("Error:", error.message);
      throw new Error(error.message || "Unknown error occurred");
    }
  }
};



export {getUserPolicy};